// @flow
import React, { Component } from 'react';
import { fonts, colors, components } from '@peachjar/components';
import { css, cx } from 'react-emotion';

import { APOLLO_QUERY_INITIAL_LOAD } from '../../../constants';
import { mdFormClasses } from '../md-form.css';

const { ButtonSecondarySmall } = components.Buttons;
const { Spinner } = components.LoadingIndicators;
const { ProximaNova } = fonts;
const { prussian } = colors;

const styles = {
  referralCodeBox: css({
    width: '513px',
    height: '128px',
    borderRadius: '6px',
    border: 'solid 1px #e6e6e6',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: '24px',
  }),
  innerReferralCodeBox: css({
    width: '397px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  referralInput: css({
    width: '310px',
    height: '40px',
    borderBottom: '2px solid #2d344b',
    fontFamily: ProximaNova,
    fontSize: '19px',
    color: prussian,
  }),
  referralInputLabel: css`
     {
      top: -1.1rem !important;
    }
  `,
};

type State = {|
  discountInput: string,
|};

type Props = {|
  handleTempDiscountCodeInput: Function,
|};

class ReferralCodeSection extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      discountInput: '',
    };
  }

  render() {
    if (this.props.inputVisible) {
      const { discountInput } = this.state;
      const {
        handleTempDiscountCodeInput,
        numberOfSchools,
        discountLoading,
        discountNetworkStatus,
      } = this.props;
      return (
        <div className={styles.referralCodeBox}>
          <div className={styles.innerReferralCodeBox}>
            <div className={cx(mdFormClasses, 'referral-button-input')}>
              <label
                htmlFor="discountCode"
                className={styles.referralInputLabel}
              >
                Referral Code
              </label>

              <input
                data-testid="field-discountCode"
                name="discountCode"
                type="text"
                className={styles.referralInput}
                onChange={e => this.setState({ discountInput: e.target.value })}
              />
            </div>

            <ButtonSecondarySmall
              data-testid="submit-applyDiscountCode"
              type="submit"
              disabled={numberOfSchools < 1 || !numberOfSchools}
              onClick={() => handleTempDiscountCodeInput(discountInput)}
            >
              {discountLoading &&
                discountNetworkStatus !== APOLLO_QUERY_INITIAL_LOAD && (
                  <Spinner />
                )}{' '}
              Apply
            </ButtonSecondarySmall>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default ReferralCodeSection;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/components/ReferralCodeSection.jsx